import { makeVar, ReactiveVar } from '@apollo/client'
import { useActiveStoreView } from '@emico-hooks/use-active-storeview'
import { syncReactiveVar } from '@emico-utils/reactive-var-utils'
import { createContext, ReactNode, useContext, useMemo } from 'react'

const LoginTokenContext = createContext<ReactiveVar<string | undefined>>(
  makeVar<string | undefined>(undefined),
)

interface LoginTokenProviderProps {
  children: ReactNode
}

export function LoginTokenProvider({ children }: LoginTokenProviderProps) {
  const storeView = useActiveStoreView()
  const rv = useMemo(() => {
    const emptyVar = makeVar<string | undefined>(undefined)
    const rv = syncReactiveVar(
      emptyVar,
      `${storeView?.websiteId}/customer/token`,
    )

    return rv
  }, [storeView?.websiteId])

  return (
    <LoginTokenContext.Provider value={rv}>
      {children}
    </LoginTokenContext.Provider>
  )
}

export function useLoginTokenContext() {
  return useContext(LoginTokenContext)
}
